<template>
  <section>
    <label style="padding: 0" for="selectedOtherZips">Telephelyek</label>
    <div v-for="zipCode in selectedOtherZips" v-bind:key="zipCode.id" class="d-flex row">
      <ZipCodeSelector
        @selected-zipCode="onZipCodeChange(zipCode.id, $event)"
        :alreadySelected="zipCode.zipCode"
        :class="`col-11 ${zipCode.id !== '0' ? 'mt-3' : ''} `"
      />
      <div class="col-1 d-flex align-items-center justify-content-end" style="padding: 0px; height: 48px;">
        <font-awesome-icon
          icon="fa-solid fa-trash"
          class="cursor-pointer mt-4 mr-3 mr-sm-2"
          @click="deleteZipCode(zipCode.id)"
        />
      </div>
    </div>
    <p class="cursor-pointer mt-5" @click="addExtraZipCode">
      <strong class="add-more">+ További lehetséges telephelyek megadása </strong>
    </p>
  </section>
</template>

<script>
import ZipCodeSelector from '../../../components/zipCodeSelector/zipCodeSelector.vue'
import errorToast from '../../../mixins/toastError'
export default {
  mixins: [errorToast],
  props: {
    alreadySelected: { type: Array },
    maximumExtraFieldRule: { type: Number, default: 100 }
  },
  data() {
    return {
      selectedOtherZips: [{ id: '0', zipCode: '' }]
    }
  },
  components: { ZipCodeSelector },
  methods: {
    onZipCodeChange(id, value) {
      const newAr = this.selectedOtherZips
        .map(zipCode => {
          if (zipCode.id === id) {
            return { id, zipCode: value }
          }
          return zipCode
        })
        .filter(x => x !== undefined)
      this.selectedOtherZips = newAr
    },
    addExtraZipCode() {
      if (this.selectedOtherZips.length < this.maximumExtraFieldRule) {
        let newItem = {
          id: (Number(this.selectedOtherZips[this.selectedOtherZips.length - 1].id) + 1).toString(),
          zipCode: ''
        }
        this.selectedOtherZips.push(newItem)
      } else {
        this.errorToast('Elérte a maximálisan rögzíthető tevékenységek / telephelyek számát!')
      }
    },
    deleteZipCode(id) {
      if (id === '0') {
        return (this.selectedOtherZips = [{ id: '0', zipCode: '' }])
      }
      const newAr = this.selectedOtherZips
        .map(zipCode => {
          if (zipCode.id === id) {
            return
          }
          return zipCode
        })
        .filter(x => x !== undefined)
      this.selectedOtherZips = newAr
    }
  },
  watch: {
    selectedOtherZips: {
      handler(value) {
        if (value[0].zipCode !== '') {
          this.$emit('selected-other-zips', value)
        } else {
          this.$emit('selected-other-zips', [])
        }
      },
      deep: true
    }
  },
  created() {
    if (this.alreadySelected.length > 0) {
      this.selectedOtherZips = this.alreadySelected
    }
  }
}
</script>

<style lang="scss" scoped>
.add-more {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  color: #00903c;
  cursor: pointer;
  display: flex;
  justify-content: end;
}
</style>
